import type { FrameworkIntegration, IntegrationMetadata } from './types.js';
import { langchainIntegration } from './langchain.js';
import { langgraphIntegration } from './langgraph.js';
import { vercelAiIntegration } from './vercel-ai.js';
import { openaiIntegration } from './openai.js';

export const frameworkRegistry = new Map<string, FrameworkIntegration>([
  ['langchain', langchainIntegration],
  ['langgraph', langgraphIntegration],
  ['vercel-ai', vercelAiIntegration],
  ['openai', openaiIntegration],
]);

export const frameworkMetadata: IntegrationMetadata[] = [
  {
    name: 'langchain',
    displayName: 'LangChain',
    description: 'Popular LLM application framework',
    npmPackage: 'langchain',
    mutagentPackage: '@mutagent/langchain',
    website: 'https://js.langchain.com',
  },
  {
    name: 'langgraph',
    displayName: 'LangGraph',
    description: 'Agent workflow framework built on LangChain',
    npmPackage: '@langchain/langgraph',
    mutagentPackage: '@mutagent/langchain',
    website: 'https://langchain-ai.github.io/langgraphjs/',
  },
  {
    name: 'vercel-ai',
    displayName: 'Vercel AI SDK',
    description: 'AI SDK for building streaming chat UIs',
    npmPackage: 'ai',
    mutagentPackage: '@mutagent/vercel-ai',
    website: 'https://sdk.vercel.ai',
  },
  {
    name: 'openai',
    displayName: 'OpenAI SDK',
    description: 'Official OpenAI SDK with automatic tracing',
    npmPackage: 'openai',
    mutagentPackage: '@mutagent/openai',
    website: 'https://platform.openai.com',
  },
];

export function getFramework(name: string): FrameworkIntegration | undefined {
  return frameworkRegistry.get(name);
}

export function getFrameworkMetadata(name: string): IntegrationMetadata | undefined {
  return frameworkMetadata.find((f) => f.name === name);
}

export function listFrameworks(): IntegrationMetadata[] {
  return frameworkMetadata;
}

export async function detectFramework(): Promise<{ name: string; confidence: number } | null> {
  const results: { name: string; confidence: number }[] = [];

  for (const [name, integration] of frameworkRegistry) {
    const detection = await integration.detect();
    if (detection.detected) {
      results.push({ name, confidence: detection.confidence });
    }
  }

  // Sort by confidence
  results.sort((a, b) => b.confidence - a.confidence);

  return results[0] ?? null;
}
